import React, { useState } from 'react';
import { Mail, HandshakeIcon, Send, Clock, CheckCircle2, AlertCircle, Search, Filter, MoreVertical, Eye, Reply } from 'lucide-react';
const dealEmails = [{
  id: 1,
  dealName: 'Via Montenapoleone 12 - Luxury Fashion',
  brandName: 'Premium Lifestyle Co.',
  lastEmail: '2 ore fa',
  status: 'waiting_response',
  emailsSent: 3,
  emailsReceived: 2
}, {
  id: 2,
  dealName: 'Corso Buenos Aires 45 - Retail',
  brandName: 'Fashion Boutique Milano',
  lastEmail: '1 giorno fa',
  status: 'active',
  emailsSent: 5,
  emailsReceived: 4
}, {
  id: 3,
  dealName: 'Via della Spiga 28 - Showroom',
  brandName: 'Design Excellence',
  lastEmail: '3 giorni fa',
  status: 'needs_followup',
  emailsSent: 2,
  emailsReceived: 1
}];
export function DealEmails() {
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const getStatusConfig = (status: string) => {
    switch (status) {
      case 'active':
        return {
          label: 'Attiva',
          color: 'bg-green-100 text-green-800',
          icon: CheckCircle2
        };
      case 'waiting_response':
        return {
          label: 'In Attesa',
          color: 'bg-yellow-100 text-yellow-800',
          icon: Clock
        };
      case 'needs_followup':
        return {
          label: 'Follow-up',
          color: 'bg-red-100 text-red-800',
          icon: AlertCircle
        };
      default:
        return {
          label: 'Sconosciuto',
          color: 'bg-gray-100 text-gray-800',
          icon: AlertCircle
        };
    }
  };
  return <div className="space-y-6" data-id="element-898">
      <div className="flex items-center justify-between" data-id="element-899">
        <div data-id="element-900">
          <h1 className="text-2xl font-semibold text-gray-900" data-id="element-901">
            Email Trattative
          </h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-902">
            Gestisci la comunicazione con i clienti per ogni trattativa
          </p>
        </div>
      </div>
      {/* Stats */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-903">
        <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-904">
          <div className="flex items-center gap-3 mb-2" data-id="element-905">
            <div className="w-10 h-10 bg-[#1388ad]/10 rounded-lg flex items-center justify-center" data-id="element-906">
              <HandshakeIcon className="w-5 h-5 text-[#1388ad]" data-id="element-907" />
            </div>
            <div data-id="element-908">
              <p className="text-sm text-gray-500" data-id="element-909">Trattative Attive</p>
              <p className="text-2xl font-semibold text-gray-900" data-id="element-910">
                {dealEmails.length}
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-911">
          <div className="flex items-center gap-3 mb-2" data-id="element-912">
            <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-913">
              <Send className="w-5 h-5 text-green-600" data-id="element-914" />
            </div>
            <div data-id="element-915">
              <p className="text-sm text-gray-500" data-id="element-916">Email Inviate</p>
              <p className="text-2xl font-semibold text-gray-900" data-id="element-917">
                {dealEmails.reduce((sum, d) => sum + d.emailsSent, 0)}
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-918">
          <div className="flex items-center gap-3 mb-2" data-id="element-919">
            <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center" data-id="element-920">
              <Mail className="w-5 h-5 text-blue-600" data-id="element-921" />
            </div>
            <div data-id="element-922">
              <p className="text-sm text-gray-500" data-id="element-923">Email Ricevute</p>
              <p className="text-2xl font-semibold text-gray-900" data-id="element-924">
                {dealEmails.reduce((sum, d) => sum + d.emailsReceived, 0)}
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-925">
          <div className="flex items-center gap-3 mb-2" data-id="element-926">
            <div className="w-10 h-10 bg-yellow-100 rounded-lg flex items-center justify-center" data-id="element-927">
              <Clock className="w-5 h-5 text-yellow-600" data-id="element-928" />
            </div>
            <div data-id="element-929">
              <p className="text-sm text-gray-500" data-id="element-930">In Attesa</p>
              <p className="text-2xl font-semibold text-gray-900" data-id="element-931">
                {dealEmails.filter(d => d.status === 'waiting_response').length}
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Filters */}
      <div className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-932">
        <div className="flex flex-col sm:flex-row gap-4" data-id="element-933">
          <div className="flex-1" data-id="element-934">
            <div className="relative" data-id="element-935">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" data-id="element-936" />
              <input type="text" placeholder="Cerca trattative..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-937" />
            </div>
          </div>
          <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-938">
            <Filter className="w-4 h-4" data-id="element-939" />
            <span className="text-sm" data-id="element-940">Filtri</span>
          </button>
        </div>
      </div>
      {/* Deals List */}
      <div className="space-y-4" data-id="element-941">
        {dealEmails.map(deal => {
        const statusConfig = getStatusConfig(deal.status);
        const StatusIcon = statusConfig.icon;
        return <div key={deal.id} className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-942">
              <div className="flex items-start justify-between mb-4" data-id="element-943">
                <div className="flex items-start gap-4 flex-1" data-id="element-944">
                  <div className="w-12 h-12 bg-[#1388ad]/10 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-945">
                    <HandshakeIcon className="w-6 h-6 text-[#1388ad]" data-id="element-946" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-947">
                    <h3 className="text-lg font-semibold text-gray-900 mb-1" data-id="element-948">
                      {deal.dealName}
                    </h3>
                    <p className="text-sm text-gray-500 mb-3" data-id="element-949">
                      {deal.brandName}
                    </p>
                    <div className="flex items-center gap-4 flex-wrap" data-id="element-950">
                      <span className={`px-2 py-1 text-xs font-medium rounded-full ${statusConfig.color} flex items-center gap-1`} data-id="element-951">
                        <StatusIcon className="w-3 h-3" data-id="element-952" />
                        {statusConfig.label}
                      </span>
                      <div className="flex items-center gap-2 text-sm text-gray-500" data-id="element-953">
                        <Clock className="w-4 h-4" data-id="element-954" />
                        <span data-id="element-955">Ultimo contatto: {deal.lastEmail}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-2 ml-4" data-id="element-956">
                  <button className="flex items-center gap-2 px-3 py-2 bg-[#1388ad] text-white rounded-lg hover:bg-[#0f6b8a] transition-colors text-sm" data-id="element-957">
                    <Reply className="w-4 h-4" data-id="element-958" />
                    Rispondi
                  </button>
                  <button className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-959">
                    <MoreVertical className="w-4 h-4 text-gray-400" data-id="element-960" />
                  </button>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4 pt-4 border-t border-gray-200" data-id="element-961">
                <div className="flex items-center gap-3" data-id="element-962">
                  <Send className="w-4 h-4 text-gray-400" data-id="element-963" />
                  <div data-id="element-964">
                    <p className="text-xs text-gray-500" data-id="element-965">Email Inviate</p>
                    <p className="text-sm font-semibold text-gray-900" data-id="element-966">
                      {deal.emailsSent}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3" data-id="element-967">
                  <Mail className="w-4 h-4 text-gray-400" data-id="element-968" />
                  <div data-id="element-969">
                    <p className="text-xs text-gray-500" data-id="element-970">Email Ricevute</p>
                    <p className="text-sm font-semibold text-gray-900" data-id="element-971">
                      {deal.emailsReceived}
                    </p>
                  </div>
                </div>
              </div>
            </div>;
      })}
      </div>
    </div>;
}